// ------------------------------------
// Constants
// ------------------------------------
import axios from 'axios'
import constants from '../lib/constants'
import jwtDecode from 'jwt-decode'
import { browserHistory } from 'react-router'
import _ from 'lodash'

export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const UPDATE_USER = 'UPDATE_USER'
export const GET_USERS = 'GET_USERS'
export const GET_USERS_COMPLETE = 'GET_USERS_COMPLETE'
export const CREATE_USER = 'CREATE_USER'
export const CREATE_USER_COMPLETE = 'CREATE_USER_COMPLETE'
export const ASSOCIATE_DEVICES = 'ASSOCIATE_DEVICES'
export const ASSOCIATE_DEVICES_COMPLETE = 'ASSOCIATE_DEVICES_COMPLETE'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const RESET_PASSWORD_COMPLETE = 'RESET_PASSWORD_COMPLETE'

// ------------------------------------
// Actions
// ------------------------------------

let TOKEN = localStorage.getItem('authToken')

if (TOKEN) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${TOKEN}`
}


export const login = (email, password) => {
  return (dispatch, getState) => {
    return dispatch(logout())
    .then(() => {
      return axios.post(`${constants.API_URL}/auth/login`, {
        email,
        password
      })
      .then((response) => {
        if (response.data.auth_token) {
          const authToken = response.data.auth_token
          localStorage.setItem('authToken', authToken)
          axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`
          dispatch({
            type: LOGIN,
            payload: {
              authToken
            }
          })
        }
        return response
      })
    })
  }
}

export const submitMFA = (email, otp) => {
  return (dispatch, getState) => {
    return dispatch(logout())
    .then(() => {
      return axios.post(`${constants.API_URL}/auth/verify_otp`, {
        email,
        otp
      })
      .then((response) => {
        const authToken = response.data.auth_token
        localStorage.setItem('authToken', authToken)
        axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`
        dispatch({
          type: LOGIN,
          payload: {
            authToken
          }
        })
        return response
      })
    })
  }
}

export const getUser = (email) => {
  return (dispatch) => {
    return axios.get(`${constants.API_URL}/auth/status`)
    .then((resp) => {
      if (resp.data) {
        return dispatch({
          type: UPDATE_USER,
          payload: resp.data
        })
      }
    })
  }
}

export const getUsers = (role = null) => {
  return (dispatch, getState) => {
    dispatch({ type: GET_USERS })
    const params = {}
    if (role) {
      params.role = role
    }
    return axios.get(`${constants.API_URL}/users/list`, { params })
    .then((response) => {
      const sortedUsers = response.data.users.sort((a, b) => (a.email > b.email ? 1 : -1))
      dispatch({
        type    : GET_USERS_COMPLETE,
        payload : {
          users: sortedUsers,
        }
      })
      return response
    })
  }
}

export const createUser = (email, password, role, organization_id) => {
  return (dispatch) => {
    dispatch({ type: CREATE_USER })
    return axios.post(`${constants.API_URL}/auth/register`,
      {
        email,
        password,
	role,
        organization_id,
      }
    )
    .then((response) => {
      // this just returns an auth token
      const userInfo = jwtDecode(response.data.auth_token)
      dispatch({
        type    : CREATE_USER_COMPLETE,
        payload : {
          createdUser: {
            email,
            user_id: userInfo.sub
          }
        }
      })
      return response
    })
  }
}

export const associateDevicesWithUser = (userId, deviceIds) => {
  return (dispatch) => {
    dispatch({ type: ASSOCIATE_DEVICES })
    return axios.post(`${constants.API_URL}/users/${userId}/associate_devices`,
      {
        device_ids: deviceIds,
      }
    )
    .then((response) => {
      const updatedUser = response.data
      dispatch({
        type    : ASSOCIATE_DEVICES_COMPLETE,
        payload : {
          updatedUser
        }
      })
    })
  }
}

export const logout = () => {
  return (dispatch) => {
    localStorage.removeItem('authToken')
    TOKEN = null
    return new Promise((resolve) => {
      resolve(dispatch({
        type: LOGOUT
      }))
    })
  }
}

export const resetPassword = (email, newPassword) => {
  return (dispatch) => {
    dispatch({ type: RESET_PASSWORD })
    return axios.post(`${constants.API_URL}/auth/reset_password`,
      {
        email,
        new_password: newPassword,
      }
    )
    .then((response) => {
      dispatch({
        type    : RESET_PASSWORD_COMPLETE,
        payload : {
          passwordReset: response.status === 200
        }
      })
      return response
    })
  }
}

const ACTION_HANDLERS = {
  [LOGIN]  : (state, action) => {
    const { authToken } = action.payload
    const user = jwtDecode(authToken)
    return _.merge({}, state, user)
  },
  [LOGOUT] : (state, action) => {
    return {}
  },
  [UPDATE_USER]: (state, action) => {
    if (action.payload) {
      const user = action.payload
      return _.merge({}, state, user)
    }
  },
  [GET_USERS_COMPLETE]: (state, action) => {
    const { users } = action.payload
    console.log("users", users, state)
    const newState = {
      ...state,
      users,
    }
    return newState
  },
  [CREATE_USER_COMPLETE]: (state, action) => {
    const { createdUser } = action.payload
    const newState = {
      ...state,
      createdUser,
    }
    return newState
  },
  [ASSOCIATE_DEVICES_COMPLETE]: (state, action) => {
    const { updatedUser } = action.payload
    const newState = {
      ...state,
      updatedUser,
    }
    return newState
  },
  [RESET_PASSWORD_COMPLETE]: (state, action) => {
    const { passwordReset } = action.payload
    const newState = {
      ...state,
      passwordReset,
    }
    return newState
  }
}

const initialToken = localStorage.getItem('authToken')

let decodedToken = {}
try {
  decodedToken = jwtDecode(initialToken)
} catch (e) {
  console.log('Could not decode')
}

const initialState = initialToken ? _.merge({}, decodedToken, {
  data: {
    patients: [
      'Bob',
      'Pam'
    ]
  },
  users: [],
  createdUser: null,
  updatedUser: null,
}) : null

export default function userReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/user.js